export const ROUTE_PATHS = {
  HOME: '/home',
};

export const buildRoutePath = {
  BottomSheet: {},
};
